module.exports = __webpack_public_path__ + "public/StoreIcon/non-veg.svg?bcb96221";